const firebaseConfig = {
  apiKey: "AIzaSyAmNNB2WNcc0vlNGi3HiwVCfeucGuTsrOs",
  authDomain: "your-doctor-851cc.firebaseapp.com",
  projectId: "your-doctor-851cc",
  storageBucket: "your-doctor-851cc.appspot.com",
  messagingSenderId: "1008862885698",
  appId: "1:1008862885698:web:a8b219eed4a261a5d47adb",
};
export default firebaseConfig;
